import { fromJS } from 'immutable';
import { isString } from '../../../../../form/formUtilities';

export const tsunamiEventSearchModel = fromJS({
  name: 'tsunamiEventSearchForm',
  initialValues: {
    id: '',
    minId: '',
    maxId: '',
    minYear: '',
    maxYear: '',
    regionCode: '',
    country: '',
    area: '',
    minLatitude: '',
    maxLatitude: '',
    minLongitude: '',
    maxLongitude: '',
    minEventValidity: '',
    maxEventValidity: '',
    minCauseCode: '',
    maxCauseCode: '',
    causeCode: '',
    minEqMagnitude: '',
    maxEqMagnitude: '',
    oceanicTsunami: '',
    runupRegion: '',
    runupCountry: '',
    runupArea: '',
    runupMinDistance: '',
    runupMaxDistance: '',
    runupMinTravelTime: '',
    runupMaxTravelTime: '',
    minNumRunups: '',
    maxNumRunups: '',
    minMaxWaterHeight: '',
    maxMaxWaterHeight: '',
    minDeaths: '',
    maxDeaths: '',
    minDeathsAmountOrder: '',
    maxDeathsAmountOrder: '',
    minInjuries: '',
    maxInjuries: '',
    minInjuriesAmountOrder: '',
    maxInjuriesAmountOrder: '',
    minDamageMillionsDollars: '',
    maxDamageMillionsDollars: '',
    minDamageAmountOrder: '',
    maxDamageAmountOrder: '',
    minHousesDestroyed: '',
    maxHousesDestroyed: '',
    minHousesDestroyedAmountOrder: '',
    maxHousesDestroyedAmountOrder: '',
    minDeathsTotal: '',
    maxDeathsTotal: '',
    minDeathsAmountOrderTotal: '',
    maxDeathsAmountOrderTotal: '',
    minDamageMillionsDollarsTotal: '',
    maxDamageMillionsDollarsTotal: '',
    minDamageAmountOrderTotal: '',
    maxDamageAmountOrderTotal: '',
    runupMeasureType: '',
    runupDoubtful: '',
    runupValidity: '',
    runupMinHeight: '',
    runupMaxHeight: '',
    runupMinDeaths: '',
    runupMaxDeaths: '',
    runupMinDeathsAmountOrder: '',
    runupMaxDeathsAmountOrder: '',
    runupMinInjuries: '',
    runupMaxInjuries: '',
    runupMinInjuriesAmountOrder: '',
    runupMaxInjuriesAmountOrder: '',
    runupMinDamageMillionsDollars: '',
    runupMaxDamageMillionsDollars: '',
    runupMinDamageAmountOrder: '',
    runupMaxDamageAmountOrder: '',
    runupMinHousesDestroyed: '',
    runupMaxHousesDestroyed: '',
    runupMinHousesDestroyedAmountOrder: '',
    runupMaxHousesDestroyedAmountOrder: '',
    assocDeposits: '',

    radios: {
      locationSearchType: 'locInclude',
      loc: '',
      commentsSearchType: 'commentsInclude',
      comments: '',
      runupLocationSearchType: 'runupLocInclude',
      runupLoc: '',
    },
  },
});


export const toSearchParameters = (model, dataManager) => {
  const search = model.toJS();
  const {
    radios: {
      locationSearchType,
      loc,
      commentsSearchType,
      comments,
      runupLocationSearchType,
      runupLoc,
    },
  } = search;

  if (locationSearchType) {
    search[locationSearchType] = loc;
  }

  if (commentsSearchType) {
    search[commentsSearchType] = comments;
  }

  if (runupLocationSearchType) {
    search[runupLocationSearchType] = runupLoc;
  }

  delete search.radios;


  Object.keys(search).forEach((key) => {
    let value = search[key];
    if (isString(value)) {
      value = value.trim();
      if (value) {
        search[key] = value;
      } else {
        delete search[key];
      }
    }
  });

  if (!dataManager) {
    delete search.id;
    delete search.minId;
    delete search.maxId;
  }

  return search;
};
